import { ScreenSize } from '$lib/enums';
import { screenSizeFromWidth } from '$lib/utils/screen';

class ScreenStore {
	width = $state(document.body.clientWidth);
	size = $derived(screenSizeFromWidth(this.width));
	isMobile = $derived(this.size === ScreenSize.MOBILE);
	#observer?: ResizeObserver;

	/** Tracks `document.body` width; idempotent. */
	observe(): void {
		if (this.#observer) return;
		this.width = document.body.clientWidth;
		this.#observer = new ResizeObserver(() => {
			this.width = document.body.clientWidth;
		});
		this.#observer.observe(document.body);
	}

	/** Stops tracking. */
	dispose(): void {
		this.#observer?.disconnect();
		this.#observer = undefined;
	}
}

export const screenStore = new ScreenStore();

export const getScreenSize = (): ScreenSize => screenStore.size;
